import { render, staticRenderFns } from "./dplayerA.vue?vue&type=template&id=009a4718&scoped=true"
import script from "./dplayerA.vue?vue&type=script&lang=js"
export * from "./dplayerA.vue?vue&type=script&lang=js"
import style0 from "./dplayerA.vue?vue&type=style&index=0&id=009a4718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a4718",
  null
  
)

export default component.exports